import type { OnPageTransitionStartSync } from "vike/types";

// Store navigation state in a way that can be accessed by client components
// Initialize as a simple object to avoid any potential SSR issues
const navigationState: { isNavigating: boolean } = { isNavigating: false };

export const onPageTransitionStart: OnPageTransitionStartSync = () => {
  // Mark navigation as started - this will be picked up by NavigationContext
  // This runs on both server and client, but we only dispatch events on client
  if (typeof window === 'undefined') {
    // SSR: do nothing, just return
    return;
  }

  // Client-side only code
  try {
    // Track if this is the initial page load (SSR hydration)
    const isInitialLoad = !(window as any).__vikeHasNavigated;
    
    // Don't trigger navigation progress on initial SSR page load
    if (isInitialLoad) {
      return;
    }
    
    navigationState.isNavigating = true;
    
    // Export getter for client-side access (set it here to ensure it's available)
    (window as any).__vikeNavigationState = navigationState;
    
    // Dispatch custom event that NavigationContext can listen to
    // Use a small delay to ensure the event is dispatched after React has mounted
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('vike:pageTransitionStart'));
      }
    }, 0);
  } catch (error) {
    // Silently fail if there's any error (e.g., during SSR or module loading)
    console.warn('[onPageTransitionStart] Error:', error);
  }
};
